<template>
  <v-snackbar
    v-model="exibeSnackbar"
    :timeout="timeout"
    :color="color"
    :vertical="true"
    top
  >
    {{ message }}

    <template>
      <v-btn
        :class="`${color} lighten-1`"
        outlined
        dark
        text
        @click="exibeSnackbar = false"
      >
        Fechar
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
  import { VSnackbar } from 'vuetify/lib'
  export default {
    name: 'DashboardCoreSnackbar',
    extends: VSnackbar,
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      timeout: {
        type: Number,
        default: 2000,
      },
      color: {
        type: String,
        default: 'black',
      },
      message: {
        type: String,
        default: 'Msg padrão do Snackbar...',
      },
    },

    data: () => ({
      exibeSnackbar: false,
    }),

    watch: {
      visible: function (val) {
        this.exibeSnackbar = val
      },
    },

  }
</script>

<style>

</style>
